var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
import { forwardRef } from "react";
const SvgIconCameraOn = (_ref, ref) => {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 24,
    height: 24,
    viewBox: "0 0 24 24",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: ref,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M4.81335 18.9168H14.2531C15.9731 18.9168 17 17.9242 17 16.2127V7.73224C17 6.0122 16.0587 5.01953 14.3386 5.01953H4.81335C3.17032 5.01953 2.06641 6.0122 2.06641 7.73224V16.2127C2.06641 17.9242 3.0933 18.9168 4.81335 18.9168ZM18 14.4926L21.0212 17.1882C21.3121 17.445 21.6544 17.6075 21.9625 17.6075C22.63 17.6075 23.0664 17.1198 23.0664 16.4181V7.51831C23.0664 6.8166 22.63 6.32882 21.9625 6.32882C21.6544 6.32882 21.3121 6.49141 21.0212 6.74814L18 9.43518V14.4926Z",
    fill: "#878793"
  })));
};
const ForwardRef = /*#__PURE__*/forwardRef(SvgIconCameraOn);
export { ForwardRef as ReactComponent };
export default __webpack_public_path__ + "static/media/icon-camera-on.92c843925a43b97ad036636a93b08ea1.svg";